// File: src/components/QuestionForm.jsx
import React, { useState, useEffect, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import chatquestion from "../../../css/chatBuilder.module.css";
import JsonTreeEditor from "./JsonEditor";
import { Button } from "react-bootstrap";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { IoMdRemoveCircle } from "react-icons/io";

const regexOptions = [
  { id: "email", name: "Email" },
  { id: "mobile", name: "Mobile Number" },
  { id: "date", name: "Date" },
  { id: "number", name: "Number Only" },
  { id: "regex", name: "Regex" },
];

export default function QuestionForm({
  onSave,
  onCancel,
  onDelete,
  allQuestions = {},
  editQuestion = null,
  start_id,
  setStart_id,
}) {
  const DEFAULT_RESPONSE_STRUCTURE = {
    question_path: "data.question",
    response_key_path: "data.response_key",
    response_type_path: "data.response_type",
    options_path: "data.options",
    has_more_path: "data.has_more",
    next_input_path: "data.next_input",
    response_value: "data.value",
  };
  const DEFAULT_API_ENTRY = {
    url: "",
    method: "POST",
    headers: "",
    body: "",
    params: "",
    response_structure: { ...DEFAULT_RESPONSE_STRUCTURE },
    exit_to: "",
  };
  const [questionId, setQuestionId] = useState(null);
  const [questionText, setQuestionText] = useState("");
  const [referenceId,setReferenceId]=useState("");
  const [responseType, setResponseType] = useState("text");
  const [responseKey, setResponseKey] = useState("");
  const [options, setOptions] = useState([""]);
  // const [isApiEnabled, setIsApiEnabled] = useState(false);
  const [isIntentZone, setIsIntentZone] = useState(false);
  const [isIntents, setIsIntents] = useState(false);
  const [isResponse, setIsResponse] = useState(false);
  const [apiDetailsQuestions, setApiDetailsQuestions] = useState({
    url: "",
    method: "POST",
    headers: "",
    body: "",
    response_structure: { ...DEFAULT_RESPONSE_STRUCTURE },
    exit_to: "",
    isValueBasedBranchingEnabled: false,
    response_values: [],
  });
  const [apiDetails, setApiDetails] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({
    type:"",
    throwError:false,
    throwErrorText:""
  });
  const [customRegex, setCustomRegex] = useState(null);

  const [isApiEnabled, setIsApiEnabled] = useState([]);
  const [isApiEnabledQuestion, setIsApiEnabledQuestion] = useState(false);

  const [branches, setBranches] = useState([]);
  const [parentId, setParentId] = useState("");
  const [errors, setErrors] = useState([]);
  const [responseGroup, setResponseGroup] = useState("");
  const [next, setNextId] = useState("");

  useEffect(() => {
    if (editQuestion) {
      console.log(editQuestion.api_loop, "editQuestion");
      setQuestionId(editQuestion.id);
      setQuestionText(editQuestion.question);
      setReferenceId(editQuestion.referenceId||"");
      setResponseKey(editQuestion.response_key);
      setResponseType(editQuestion.response_type);
      setOptions(editQuestion.options || [""]);
      setSelectedOptions(editQuestion?.validations || null);
      setCustomRegex(editQuestion?.validations?.regex || null);
      setBranches(editQuestion.branches || []);
      setParentId(editQuestion.parentId || "");
      setNextId(editQuestion.next || "");
      setIsIntentZone(editQuestion.is_intent_zone || false);
      setIsIntents(editQuestion.is_intents || false);
      setIsResponse(editQuestion.is_response || false);
      if (editQuestion.api_loop) {
        setIsApiEnabledQuestion(true);
        setApiDetailsQuestions({
          ...editQuestion.api_loop.entry_point,
          response_structure: editQuestion.api_loop.response_structure,
          exit_to: editQuestion.api_loop.exit_to,
          isValueBasedBranchingEnabled:
            editQuestion.api_loop.isValueBasedBranchingEnabled,
          response_values: editQuestion.api_loop.response_values,
        });
      } else {
        // explicitly reset to false if not present
        setIsApiEnabledQuestion(false);
        setApiDetailsQuestions({
          url: "",
          method: "POST",
          headers: "",
          body: "",
          response_structure: { ...DEFAULT_RESPONSE_STRUCTURE },
          exit_to: "",
          isValueBasedBranchingEnabled: false,
          response_values: [],
        });
      }
      if (editQuestion.response_group) {
        setResponseGroup(editQuestion.response_group);
      }

      const updatedBranches = (editQuestion.options || []).map((opt, idx) => {
        console.log(opt, "opt");
        const branch =
          (editQuestion.branches || []).find((b) => b.value === opt) || {};
        return {
          value: opt,
          next: branch.next || "",
          apiLoop: branch.api_loop || null,
        };
      });
      setBranches(updatedBranches);

      // ----------------- Per-option API enabled flags -----------------
      setIsApiEnabled(updatedBranches.map((b) => !!b.apiLoop));

      // ----------------- Per-option API details -----------------
      setApiDetails(
        updatedBranches.map((b) => {
          if (b.apiLoop) {
            return {
              ...b.apiLoop.entry_point,
              response_structure: b.apiLoop.response_structure || {
                ...DEFAULT_RESPONSE_STRUCTURE,
              },
              exit_to: b.apiLoop.exit_to || "",
            };
          }
          return {
            url: "",
            method: "POST",
            headers: "",
            body: "",
            response_structure: { ...DEFAULT_RESPONSE_STRUCTURE },
            exit_to: "",
          };
        })
      );

      // updateSnapshot();
    } else {
      setApiDetails((prev) => ({
        ...prev,
        response_structure: {
          question_path: "data.question",
          response_key_path: "data.response_key",
          response_type_path: "data.response_type",
          options_path: "data.options",
          has_more_path: "data.has_more",
          next_input_path: "data.next_input",
          response_value: "data.value",
        },
      }));
    }
  }, [editQuestion]);

  // useEffect(() => {
  //   const current = getFormSnapshot();
  //   const initial = initialSnapshotRef.current;
  //   if (!initial) return;

  //   const isChanged = JSON.stringify(current) !== JSON.stringify(initial);
  //   setIsDirty(isChanged);
  // }, [
  //   questionText,
  //   responseKey,
  //   responseGroup,
  //   responseType,
  //   options,
  //   branches,
  //   parentId,
  //   next,
  //   isIntentZone,
  //   isApiEnabled,
  //   apiDetails
  // ]);

  const handleStartChange = (event) => {
    if (event.target.checked) {
      setStart_id(questionId);
    } else {
      setStart_id(null);
    }
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };
  //   const updateSnapshot = () => {
  //   setTimeout(() => {
  //     initialSnapshotRef.current = getFormSnapshot();
  //     setIsDirty(false);
  //   }, 0);
  // };

  const addOption = () => {
    setOptions([...options, ""]);
  };

  const handleSave = () => {
    const id = questionId || uuidv4();
    const errorsFound = [];

    // ------------------ Basic validations ------------------
    if (!questionText.trim()) errorsFound.push("Question text is required.");
    if (!responseKey.trim()) errorsFound.push("Response key is required.");

    if (
      (responseType === "multiple_choice" || responseType === "dropdown") &&
      options.filter((opt) => opt.trim()).length < 2
    ) {
      errorsFound.push("At least two options are required.");
    }

    // ------------------ Per-option API validation ------------------
    //   branches.forEach(b => {
    // if (b.apiLoop) {
    //   const api = b.apiLoop;
    //   const entry = api.entry_point || {};

    //   if (!entry.url) errorsFound.push(`API URL is required for option '${b.value}'.`);
    //   if (!entry.method) errorsFound.push(`HTTP Method is required for option '${b.value}'.`);
    //   if (!api.exit_to) errorsFound.push(`Exit question ID is required for option '${b.value}'.`);

    //   const rs = api.response_structure || {};
    //   if (!rs.question_path && !rs.response_key_path && !rs.has_more_path) {
    //     errorsFound.push(
    //       `At least one response structure path is required for option '${b.value}'.`
    //     );
    //   }
    // }

    //   });

    if (errorsFound.length > 0) {
      setErrors(errorsFound);
      return;
    }

    // ------------------ Start ID ------------------
    if (!start_id && Object.keys(allQuestions).length === 0 && !questionId) {
      setStart_id(id);
    }

    // ------------------ Construct question data ------------------
    const data = {
      id,
      ...(referenceId && {referenceId}),
      parentId,
      next,
      question: questionText,
      response_key: responseKey,
      response_type: responseType,
      is_intent_zone: isIntentZone,
      is_intents: isIntents,
      is_response: isResponse,
      required: true,
      ...(start_id && { start_id }),
      ...(selectedOptions?.type && {
        // add validations only if not null
        validations:
          selectedOptions?.type === "Regex"
            ? { type: selectedOptions?.type, regex: customRegex,throwError:selectedOptions?.throwError,throwErrorText:selectedOptions?.throwErrorText }
            : { type: selectedOptions?.type,throwError:selectedOptions?.throwError,throwErrorText:selectedOptions?.throwErrorText },
      }),
    };

    if (responseGroup.trim()) data.response_group = responseGroup.trim();

    // ------------------ Multiple choice / dropdown ------------------
    if (responseType === "multiple_choice" || responseType === "dropdown") {
      data.options = options.filter((opt) => opt.trim() !== "");

      data.branches = options.map((opt, idx) => {
        const branch = branches[idx] || {};
        const api = apiDetails[idx]; // <-- use apiDetails here

        const branchData = { value: opt, next: branch.next || "" };

        if (api && api.url) {
          branchData.api_loop = {
            entry_point: {
              url: api.url,
              method: api.method,
              headers: api.headers,
              body: api.body,
              params: api.params,
            },
            response_values: branch?.apiLoop?.response_values,
            isValueBasedBranchingEnabled:
              branch?.apiLoop?.isValueBasedBranchingEnabled || false,
            response_structure: api.response_structure,
            loop_control: {
              continue_on_true: api.response_structure?.has_more_path,
            },
            exit_to: api.exit_to,
            response_type: responseType,
          };
        }

        return branchData;
      });
    }

    // ------------------ Parent logic ------------------
    if (parentId) {
      const parent = allQuestions[parentId];
      if (parent) {
        if (!parent.branches && parent.response_type === "text") {
          parent.next = id;
        } else if (parent.branches) {
          const branchIndex =
            parent.options?.findIndex((opt) => opt === "") ?? -1;
          if (branchIndex >= 0) {
            parent.branches.push({
              value: parent.options[branchIndex],
              next: id,
            });
          }
        }
      } else {
        setErrors([`Parent question ID '${parentId}' not found.`]);
        return;
      }
    }

    if (isApiEnabledQuestion) {
      data.api_loop = {
        entry_point: {
          url: apiDetailsQuestions.url,
          method: apiDetailsQuestions.method,
          headers: apiDetailsQuestions.headers,
          body: apiDetailsQuestions.body,
        },
        response_structure: apiDetailsQuestions.response_structure,
        isValueBasedBranchingEnabled:
          apiDetailsQuestions.isValueBasedBranchingEnabled,
        response_values: apiDetailsQuestions.response_values,
        loop_control: {
          continue_on_true:
            apiDetailsQuestions.response_structure.has_more_path,
        },
        exit_to: apiDetailsQuestions.exit_to,
      };
    }

    // ------------------ Save ------------------
    onSave(id, data);
    resetForm();
  };

  const resetForm = () => {
    setQuestionId(null);
    setQuestionText("");
    setReferenceId("");
    setResponseKey("");
    setResponseGroup("");
    setResponseType("text");
    setOptions([""]);
    setIsApiEnabled(false);
    setBranches([]);
    setParentId("");
    setApiDetails([]);
    setErrors([]);
    setIsIntentZone(false);
    setIsIntents(false);
    setIsResponse(false);
    setApiDetailsQuestions({
      url: "",
      method: "POST",
      headers: "",
      body: "",
      response_structure: { ...DEFAULT_RESPONSE_STRUCTURE },
      exit_to: "",
      isValueBasedBranchingEnabled: false,
      response_values: [],
    });
  };
  console.log(selectedOptions, "selectedOptions");
  return (
    <>
      {/* {isDirty && (
  <div className="alert alert-warning py-2 px-3 mb-2">
    <strong>Unsaved changes</strong> — don’t forget to save!
  </div>
)} */}

      <div
        className="border p-4 rounded mb-3 custom-scrollBar"
        style={{
          maxHeight: "100vh",
          overflowY: "auto",
        }}
      >
        <Button
          variant={start_id === questionId ? "primary" : "outline-primary"}
          className="mb-3"
          onClick={() => setStart_id(questionId)}
        >
          {start_id === questionId
            ? "Start Id Selected"
            : "Mark this as Start Id"}
        </Button>

        <h2 className="h5 font-weight-bold mb-4">
          {editQuestion ? "Edit Question" : "Add a Question"}
        </h2>

        {errors.length > 0 && (
          <div className="alert alert-danger">
            {errors.map((err, i) => (
              <div key={i}>{err}</div>
            ))}
          </div>
        )}

        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="intentsCheck"
            checked={isIntents}
            onChange={() => setIsIntents(!isIntents)}
          />
          <label className="form-check-label" htmlFor="intentZoneCheck">
            Mark this as an Intents
          </label>
        </div>

        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="intentZoneCheck"
            checked={isIntentZone}
            onChange={() => setIsIntentZone(!isIntentZone)}
          />
          <label className="form-check-label" htmlFor="intentZoneCheck">
            Mark this as an Intent Zone
          </label>
        </div>
        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="responseCheck"
            checked={isResponse}
            onChange={() => setIsResponse(!isResponse)}
          />
          <label className="form-check-label" htmlFor="responseCheck">
            Mark this as a Response
          </label>
        </div>
        {questionId && (
          <input
            className="form-control mb-3 bg-light"
            value={`ID: ${questionId}`}
            readOnly
            disabled
          />
        )}

               <div className="mb-3">
  <input
    type="text"
    className="form-control"
    id="referenceId"
    value={referenceId}
    onChange={(e) => setReferenceId(e.target.value)}
    placeholder="Enter Reference Id"
  />
</div>
        {/* <input
          className="form-control mb-3"
          placeholder="Question Id"
          value={questionId}
          onChange={(e) => setQuestionId(e.target.value)}
        /> */}
        <input
          className="form-control mb-3"
          placeholder="Question text"
          value={questionText}
          onChange={(e) => setQuestionText(e.target.value)}
        />

        <input
          className="form-control mb-3"
          placeholder="Response group (optional, e.g., policies or assets)"
          value={responseGroup}
          onChange={(e) => setResponseGroup(e.target.value)}
        />

        <input
          className="form-control mb-3"
          placeholder="Response key (e.g., user_name)"
          value={responseKey}
          onChange={(e) => setResponseKey(e.target.value)}
        />

        <select
          className="form-control mb-3"
          value={responseType}
          onChange={(e) => setResponseType(e.target.value)}
        >
          <option value="text">Text</option>
          <option value="multiple_choice">Multiple Choice</option>
        </select>

        <input
          className="form-control mb-3"
          placeholder="Parent Question ID (for tree linkage)"
          value={parentId}
          onChange={(e) => setParentId(e.target.value)}
        />

        <div className="pb-3 pt-3">
          <Autocomplete
            options={regexOptions.map((opt) => opt.name)}
            // getOptionLabel={(option) => option.name}
            value={selectedOptions?.type}
            // onChange={(e, newValue) => setSelectedOptions(newValue)}
            onChange={(e, newValue) => setSelectedOptions((prev)=>({
             ...prev,
             type:newValue,
             throwError:false,
             throwErrorText:""
            }))}
            renderTags={() => null}
            renderInput={(params) => (
              <TextField {...params} label="Select Regex" placeholder="Regex" />
            )}
            // isOptionEqualToValue={(option, value) => option.id === value.id}
          />

          {selectedOptions?.type === "Regex" && (
            <div>
              <TextField
                label="Enter Custom Regex"
                value={customRegex}
                onChange={(e) => setCustomRegex(e.target.value)}
                fullWidth
                margin="normal"
              />
            </div>
          )}
          {
            selectedOptions?.type &&(
              <div className="form-check mt-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="isThrowError"
            checked={selectedOptions?.throwError}
            onChange={() => setSelectedOptions((prev)=>({
              ...prev,
              throwError:!selectedOptions?.throwError,
              throwErrorText:""
            }))}
          />
          <label className="form-check-label" htmlFor="intentZoneCheck">
            isThrowError
          </label>
        </div>
            )
          }

          {
            selectedOptions?.throwError &&(
              <div className="form-check mt-3">
           <input
          className="form-control mt-2"
          placeholder="throwErrorText"
          value={selectedOptions?.throwErrorText}
          onChange={(e) => setSelectedOptions((prev)=>({
              ...prev,
              throwErrorText:e.target.value
            }))}
        />
        </div>
            )
          }
        </div>

        {(responseType === "multiple_choice" ||
          responseType === "dropdown") && (
          <div className="mb-4">
            <p className="font-weight-bold mb-2">Options:</p>
            {options.map((opt, idx) => (
              <input
                key={idx}
                className="form-control mb-2"
                placeholder={`Option ${idx + 1}`}
                value={opt}
                onChange={(e) => handleOptionChange(idx, e.target.value)}
              />
            ))}
            <button
              onClick={addOption}
              className="btn btn-link p-0 text-primary"
            >
              + Add Option
            </button>

            <p className="font-weight-bold mt-3 mb-2">
              Branching Logic (optional):
            </p>
            {options.map((opt, idx) => {
              const branchIndex = branches.findIndex((b) => b.value === opt);
              const branch = branchIndex !== -1 ? branches[branchIndex] : null;

              const updateBranch = (updates) => {
                setBranches((prev) => {
                  const idxInPrev = prev.findIndex((b) => b.value === opt);
                  if (idxInPrev !== -1) {
                    const newBranches = [...prev];
                    newBranches[idxInPrev] = {
                      ...newBranches[idxInPrev],
                      ...updates,
                    };
                    return newBranches;
                  } else {
                    return [
                      ...prev,
                      { value: opt, next: "", apiLoop: null, ...updates },
                    ];
                  }
                });
              };

              return (
                <div key={idx} className="mb-3 border p-2 rounded">
                  <div className="d-flex gap-2 mb-2 align-items-center">
                    <input className="form-control" value={opt} disabled />

                    <input
                      className="form-control"
                      placeholder="Next Question ID"
                      value={branch?.next || ""}
                      onChange={(e) => updateBranch({ next: e.target.value })}
                    />
                  </div>

                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`apiEnabledCheck-${idx}`}
                      checked={!!branch?.apiLoop}
                      onChange={() => {
                        const enabled = !branch?.apiLoop;
                        const apiData = enabled
                          ? apiDetails[idx] || { ...DEFAULT_API_ENTRY }
                          : null;
                        updateBranch({ apiLoop: apiData });

                        // Reset apiDetails if disabled
                        if (!enabled) {
                          const updatedApiDetails = [...apiDetails];
                          updatedApiDetails[idx] = { ...DEFAULT_API_ENTRY };
                          setApiDetails(updatedApiDetails);
                        }
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`apiEnabledCheck-${idx}`}
                    >
                      Enable API Loop for this Option
                    </label>
                  </div>

                  {branch?.apiLoop && (
                    <div className="bg-light p-3 border rounded mb-3">
                      <input
                        className="form-control mb-2"
                        placeholder="API URL"
                        value={apiDetails[idx]?.url || ""}
                        onChange={(e) => {
                          const updatedApi = [...apiDetails];
                          updatedApi[idx] = {
                            ...updatedApi[idx],
                            url: e.target.value,
                          };
                          setApiDetails(updatedApi);
                          updateBranch({ apiLoop: updatedApi[idx] });
                        }}
                      />
                      <select
                        className="form-control mb-2"
                        value={apiDetails[idx].method}
                        onChange={(e) => {
                          const updatedApi = [...apiDetails];
                          updatedApi[idx] = {
                            ...updatedApi[idx],
                            method: e.target.value,
                          };
                          setApiDetails(updatedApi);
                          updateBranch({ apiLoop: updatedApi[idx] });
                        }}
                      >
                        <option value="POST">POST</option>
                        <option value="GET">GET</option>
                      </select>

                      {["headers", "body", "params"].map((key) => (
                        <JsonTreeEditor
                          key={key}
                          title={key.charAt(0).toUpperCase() + key.slice(1)}
                          data={apiDetails[idx]?.[key] || {}}
                          onChange={(data) => {
                            // Update apiDetails safely
                            setApiDetails((prevApi) => {
                              const updatedApi = [...prevApi];
                              updatedApi[idx] = {
                                ...updatedApi[idx],
                                [key]: data,
                              };
                              return updatedApi;
                            });

                            // Update branch safely
                            updateBranch({
                              apiLoop: {
                                ...(branch?.apiLoop || {}),
                                [key]: data,
                              },
                            });
                          }}
                        />
                      ))}

                      <input
                        className="form-control mb-2"
                        placeholder="Exit to question ID after API loop"
                        value={apiDetails[idx].exit_to}
                        onChange={(e) => {
                          const updatedApi = [...apiDetails];
                          updatedApi[idx] = {
                            ...updatedApi[idx],
                            exit_to: e.target.value,
                          };
                          setApiDetails(updatedApi);
                          updateBranch({ apiLoop: updatedApi[idx] });
                        }}
                      />

                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <p className="font-weight-bold mb-0">
                          Response Mapping
                        </p>
                        <button
                          type="button"
                          className="btn btn-link p-0 text-primary"
                          onClick={() => {
                            const updatedApi = [...apiDetails];
                            updatedApi[idx] = {
                              ...DEFAULT_API_ENTRY,
                              response_structure: {
                                ...DEFAULT_RESPONSE_STRUCTURE,
                              },
                            };
                            setApiDetails(updatedApi);
                            updateBranch({ apiLoop: updatedApi[idx] });
                          }}
                        >
                          Reset to default
                        </button>
                      </div>

                      {Object.keys(apiDetails[idx].response_structure).map(
                        (key) => (
                          <div key={key} className="mb-2">
                            <label className="form-label small text-muted mb-0">
                              {key.replace(/_/g, " ")}
                            </label>
                            <input
                              className="form-control"
                              placeholder={`e.g., data.${key}`}
                              value={apiDetails[idx].response_structure[key]}
                              onChange={(e) => {
                                const updatedApi = [...apiDetails];
                                updatedApi[idx] = {
                                  ...updatedApi[idx],
                                  response_structure: {
                                    ...updatedApi[idx].response_structure,
                                    [key]: e.target.value,
                                  },
                                };
                                setApiDetails(updatedApi);
                                updateBranch({ apiLoop: updatedApi[idx] });
                              }}
                            />
                            {key === "response_value" && (
                              <div className="form-check mt-1">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={
                                    branch?.apiLoop
                                      ?.isValueBasedBranchingEnabled || false
                                  }
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const responseValues = isChecked
                                      ? branch?.apiLoop?.response_values || [
                                          { value: "", next: "" },
                                        ]
                                      : [];
                                    updateBranch({
                                      apiLoop: {
                                        ...(branch?.apiLoop || {}),
                                        isValueBasedBranchingEnabled: isChecked,
                                        response_values: responseValues,
                                      },
                                    });
                                  }}
                                />
                                <label className="form-check-label">
                                  Value Based Branching
                                </label>

                                {branch?.apiLoop
                                  ?.isValueBasedBranchingEnabled && (
                                  <div className="mt-2">
                                    {(branch.apiLoop.response_values || []).map(
                                      (resp, rIdx) => (
                                        <div
                                          key={rIdx}
                                          className="mb-2 d-flex gap-2"
                                        >
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Value"
                                            value={resp.value || ""}
                                            onChange={(e) => {
                                              const updatedValues = [
                                                ...(branch.apiLoop
                                                  .response_values || []),
                                              ];
                                              updatedValues[rIdx] = {
                                                ...updatedValues[rIdx],
                                                value: e.target.value,
                                              };
                                              updateBranch({
                                                apiLoop: {
                                                  ...branch.apiLoop,
                                                  response_values:
                                                    updatedValues,
                                                },
                                              });
                                            }}
                                          />
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Next"
                                            value={resp.next || ""}
                                            onChange={(e) => {
                                              const updatedValues = [
                                                ...(branch.apiLoop
                                                  .response_values || []),
                                              ];
                                              updatedValues[rIdx] = {
                                                ...updatedValues[rIdx],
                                                next: e.target.value,
                                              };
                                              updateBranch({
                                                apiLoop: {
                                                  ...branch.apiLoop,
                                                  response_values:
                                                    updatedValues,
                                                },
                                              });
                                            }}
                                          />
                                          <IoMdRemoveCircle
                                            role="button"
                                            size={35}
                                            onClick={() => {
                                              const updatedValues = [
                                                ...(branch.apiLoop
                                                  .response_values || []),
                                              ];
                                              updatedValues.splice(rIdx, 1);
                                              updateBranch({
                                                apiLoop: {
                                                  ...branch.apiLoop,
                                                  response_values:
                                                    updatedValues,
                                                },
                                              });
                                            }}
                                            className="text-danger"
                                          />
                                        </div>
                                      )
                                    )}

                                    <button
                                      type="button"
                                      className="btn btn-primary mt-2"
                                      onClick={() => {
                                        const updatedValues = [
                                          ...(branch?.apiLoop
                                            ?.response_values || []),
                                        ];
                                        updatedValues.push({
                                          value: "",
                                          next: "",
                                        });
                                        updateBranch({
                                          apiLoop: {
                                            ...branch?.apiLoop,
                                            response_values: updatedValues,
                                          },
                                        });
                                      }}
                                    >
                                      Add
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            checked={isApiEnabledQuestion}
            onChange={() => setIsApiEnabledQuestion((prev) => !prev)}
            id="apiEnabledCheck"
          />
          <label className="form-check-label" htmlFor="apiEnabledCheck">
            Enable API Loop for this question
          </label>
        </div>

        {isApiEnabledQuestion && (
          <div className="bg-light p-3 border rounded mb-3">
            <input
              className="form-control mb-2"
              placeholder="API URL"
              value={apiDetailsQuestions.url}
              onChange={(e) =>
                setApiDetailsQuestions({
                  ...apiDetailsQuestions,
                  url: e.target.value,
                })
              }
            />

            <select
              className="form-control mb-2"
              value={apiDetailsQuestions.method}
              onChange={(e) =>
                setApiDetailsQuestions({
                  ...apiDetailsQuestions,
                  method: e.target.value,
                })
              }
            >
              <option value="POST">POST</option>
              <option value="GET">GET</option>
            </select>

            <JsonTreeEditor
              title="Header"
              data={apiDetailsQuestions.headers}
              onChange={(data) =>
                setApiDetailsQuestions({
                  ...apiDetailsQuestions,
                  headers: data,
                })
              }
            />

            <JsonTreeEditor
              title="Body"
              data={apiDetailsQuestions.body}
              onChange={(data) =>
                setApiDetailsQuestions({ ...apiDetailsQuestions, body: data })
              }
            />

            <input
              className="form-control mb-2"
              placeholder="Exit to question ID after API loop"
              value={apiDetailsQuestions.exit_to}
              onChange={(e) =>
                setApiDetailsQuestions({
                  ...apiDetailsQuestions,
                  exit_to: e.target.value,
                })
              }
            />

            <div className="d-flex justify-content-between align-items-center mb-2">
              <p className="font-weight-bold mb-0">Response Mapping</p>
              <button
                type="button"
                className="btn btn-link p-0 text-primary"
                onClick={() =>
                  setApiDetailsQuestions({
                    ...DEFAULT_API_ENTRY,
                    response_structure: { ...DEFAULT_RESPONSE_STRUCTURE },
                  })
                }
              >
                Reset to default
              </button>
            </div>
            {apiDetailsQuestions.response_structure &&
              Object.keys(apiDetailsQuestions.response_structure).map((key) => (
                <div key={key} className="mb-2">
                  <label className="form-label small text-muted mb-0">
                    {key.replace(/_/g, " ")}
                  </label>
                  <input
                    className="form-control"
                    placeholder={`e.g., data.${key}`}
                    value={apiDetailsQuestions.response_structure[key]}
                    onChange={(e) =>
                      setApiDetailsQuestions((prev) => ({
                        ...prev,
                        response_structure: {
                          ...prev.response_structure,
                          [key]: e.target.value,
                        },
                      }))
                    }
                  />

                  {key === "response_value" && (
                    <div className="form-check mt-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={
                          !!apiDetailsQuestions?.isValueBasedBranchingEnabled
                        }
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const updatedapiDetailsQuestions = {
                            ...apiDetailsQuestions,
                            isValueBasedBranchingEnabled: isChecked,
                          };

                          // Optional: initialize response_data when checked
                          if (isChecked) {
                            updatedapiDetailsQuestions.response_values =
                              updatedapiDetailsQuestions.response_values || [
                                {
                                  value: "",
                                  next: "",
                                },
                              ];
                          } else {
                            updatedapiDetailsQuestions.response_values = [];
                          }

                          setApiDetailsQuestions(updatedapiDetailsQuestions);
                        }}
                      />
                      <label className="form-check-label">
                        Value Based Branching
                      </label>

                      {apiDetailsQuestions.isValueBasedBranchingEnabled && (
                        <div className="mt-2">
                          {(apiDetailsQuestions?.response_values || []).map(
                            (resp, idx) => (
                              <div key={idx} className="mb-2 d-flex gap-2">
                                <input
                                  type="text"
                                  className="form-control mb-1"
                                  placeholder="Value"
                                  value={resp.value || ""}
                                  onChange={(e) => {
                                    const updated = { ...apiDetailsQuestions };
                                    updated.response_values = [
                                      ...updated.response_values,
                                    ];
                                    updated.response_values[idx].value =
                                      e.target.value;
                                    setApiDetailsQuestions(updated);
                                  }}
                                />

                                <input
                                  type="text"
                                  className="form-control mb-1"
                                  placeholder="Next"
                                  value={resp.next || ""}
                                  onChange={(e) => {
                                    const updated = { ...apiDetailsQuestions };
                                    updated.response_values = [
                                      ...updated.response_values,
                                    ];
                                    updated.response_values[idx].next =
                                      e.target.value;
                                    setApiDetailsQuestions(updated);
                                  }}
                                />

                                <IoMdRemoveCircle
                                  role="button"
                                  size={35}
                                  onClick={() => {
                                    const updated = { ...apiDetailsQuestions };
                                    updated.response_values =
                                      updated.response_values.filter(
                                        (_, i) => i !== idx
                                      );
                                    setApiDetailsQuestions(updated);
                                  }}
                                  className="text-danger"
                                />
                              </div>
                            )
                          )}

                          {/* ➕ Add new value-next pair */}
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => {
                              const updated = { ...apiDetailsQuestions };
                              updated.response_values = [
                                ...(updated.response_values || []),
                                { value: "", next: "" },
                              ];
                              setApiDetailsQuestions(updated);
                            }}
                          >
                            Add
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
          </div>
        )}

        <div className="d-flex gap-2">
          <button className={`${chatquestion.savebtnclr}`} onClick={handleSave}>
            {editQuestion ? "Update" : "Save"}
          </button>
          {editQuestion && (
            <>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  resetForm();
                  onCancel();
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={() => onDelete(editQuestion.id)}
              >
                Delete
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
